import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getRecipe } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Overline, PrimaryButton, GhostButton } from "@/components/site/Primitives";
import { Lock } from "lucide-react";

export default function RecipeDetail() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [r, setR] = useState(null);

  useEffect(() => { getRecipe(slug).then(setR).catch(() => {}); window.scrollTo(0, 0); }, [slug, user]);
  if (!r) return <div className="min-h-[60vh] flex items-center justify-center font-serif text-2xl text-brand-muted">Fetching from the kitchen…</div>;

  return (
    <div data-testid="recipe-detail-page">
      <article className="max-w-3xl mx-auto px-6 pt-20 pb-10 text-center">
        <Overline>Daily Recipe{r.is_free ? " · free taste" : ""}</Overline>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light mt-5 mb-5 leading-tight">{r.title}</h1>
        <p className="font-body text-brand-muted text-lg italic">{r.excerpt}</p>
      </article>
      <div className="max-w-4xl mx-auto px-6"><img src={r.cover} alt={r.title} className="w-full aspect-[16/9] object-cover" /></div>

      <div className="max-w-2xl mx-auto px-6 py-14">
        {!r.locked ? (
          <>
            {r.ingredients && r.ingredients.length > 0 && (
              <div className="bg-brand-warm-white border border-brand-linen p-8 mb-10">
                <span className="overline">Ingredients</span>
                <ul className="mt-4 space-y-2">
                  {r.ingredients.map((ing, i) => (
                    <li key={i} className="font-body text-brand-body border-b border-brand-linen pb-2 last:border-0">{ing}</li>
                  ))}
                </ul>
              </div>
            )}
            <span className="overline">Method</span>
            <div className="mt-4">
              {r.body.split("\n\n").map((p, i) => (
                <p key={i} className="font-body text-brand-body text-lg leading-loose mb-6">{p}</p>
              ))}
            </div>
            <p className="font-serif text-2xl italic text-brand-olive mt-10 text-center">From my cottage to yours. — Agnes</p>
          </>
        ) : (
          <>
            <p className="font-body text-brand-body text-lg leading-loose mb-8">{r.body}…</p>
            <div className="bg-brand-sage/20 border border-brand-linen p-10 text-center" data-testid="recipe-paywall">
              <Lock size={26} className="text-brand-copper mx-auto mb-4" />
              <h2 className="font-serif text-3xl mb-3">The rest of this recipe is for members</h2>
              <p className="font-body text-brand-body mb-6">Join the Cottage Circle for $9/month to unlock the full ingredients and method — plus a fresh recipe every day and every Journal letter.</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <PrimaryButton to="/membership" testid="recipe-join-btn">Become a member</PrimaryButton>
                <GhostButton to="/account" testid="recipe-signin-btn">I already have an account</GhostButton>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
